import React from 'react';
import Axios from 'axios';
import { Link } from 'react-router-dom';
import SeasonsTable from '../../shared/Tables/SeasonsTable';
import LeagueAdminAddSeasonModal from './LeagueAdminAddSeasonModal';

class LeagueAdmin extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			league: this.props.league,
			seasons: this.props.seasons,
			showAddSeasonModal: false
		};
	
		this.handleLeagueNameChange = this.handleLeagueNameChange.bind(this);
		this.handleSaveClick = this.handleSaveClick.bind(this);
		this.handleDeleteSeason = this.handleDeleteSeason.bind(this);
	}

	componentDidMount() {
    // console.log('LeagueAdmin: componentDidMount');
    // console.log(this.props);
	}

  UNSAFE_componentWillReceiveProps(nextProps) {
    // console.log('LeagueAdmin: UNSAFE_componentWillReceiveProps');
    // console.log(nextProps);
    this.setState({
			league: nextProps.league,
			seasons: nextProps.seasons
    })
  }

  render() {
  	//console.log('LeagueAdmin: render');
  	return (
			<div className="row">
      <div className="col-md-11">
        <h5>Gestion de la Ligue</h5>

				Nom de la Ligue<br/>
      	<div className="row">
      	<div className="col-md-8">
					<input type="text" id="leagueName" className="form-control" value={this.state.league.name || ""} 
						onChange={this.handleLeagueNameChange}/>
        </div>
        </div>
				<br/>

      	<div className="row">
      	<div className="col-md-8">
					<button type="button" className="btn btn-primary" onClick={this.handleSaveClick}> Sauvegarder </button>
        </div>
        </div>
				<br/>

        <h5>Gestion des Saisons</h5>
				<SeasonsTable leagueId={this.state.league._id} seasons={this.state.seasons}
					handleDeleteSeason={this.handleDeleteSeason}>
				</SeasonsTable>
        <br/>

				<button className="btn btn-primary" onClick={() => this.setState({ showAddSeasonModal: true })}>
				  Ajouter une Saison
				</button>

				{this.state.showAddSeasonModal && (
				  <LeagueAdminAddSeasonModal
				    showModal={true}
				    league={this.state.league}
				    reloadLeagues={this.props.reloadLeagues}
				    onClose={() => this.setState({ showAddSeasonModal: false })}
				  />
				)}

      </div>
      </div>
    );
  }

  handleLeagueNameChange(event) {
  	var league = this.state.league;
  	var leagueName = event.target.value;
		league.name = leagueName;

  	this.setState({
  		league: league
  	});
  }

	handleSaveClick() {
    var _this = this;
    //console.log('this.state.league._id');
    //console.log(this.state.league._id);

		Axios.post('/api/leagues/' + this.state.league._id,
		{
			league: _this.state.league
		})
		.then(function(response) {
			//console.log(response);
			_this.props.reloadLeagues();
		});
	}

  handleDeleteSeason(event) {
  	var _this = this;
    var sIdx = event.target.name.split(".")[1];
    var seasons = this.state.seasons;
    var seasonIdToDelete = seasons[sIdx]._id;

    if(window.confirm('Retirer la saison ' + seasons[sIdx].name + '\nCliquer sur OK pour confirmer')) {

      seasons.splice(sIdx, 1);
      this.setState({seasons: seasons});

      // Post to DB
      //console.log(seasonIdToDelete);
			Axios.delete('/api/seasons/' + seasonIdToDelete).then(function(response) {
				console.log(response);
				_this.props.reloadLeagues();
			});
    }
  }

}

export default LeagueAdmin;